import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../Store/Action"; // Action untuk login
import logo from "../../assets/main_logo.png";
import naver from "../../assets/naver_login.png";
import { getWithExpiry, setWithExpiry } from "@/utils/token";
import { useThemeAsset } from "@/Hooks/useThemeAsset";
import { useThemeClass } from "@/Hooks/useThemeClass";
import clsx from "clsx";

function MainLogin() {
  const themeClass = useThemeClass();
  const { logoNavbar } = useThemeAsset();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Cek apakah sudah login
  useEffect(() => {
    const token = getWithExpiry("token");
    if (token) {
      navigate("/"); // Redirect ke home jika token ada
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(loginUser(formData));

      if (
        response?.meta?.code === 200 &&
        response?.meta?.message === "success"
      ) {
        setSuccessMessage("Login successful!");
        if (response.data?.token) {
          setWithExpiry("token", response.data.token);
          setWithExpiry("id", response.data.id);
        }
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        const code = response?.meta?.code;
        if (code === 403) {
          setErrorMessage(
            "탈퇴처리 되었습니다"
          );
        } else {
          setErrorMessage(
            "로그인에 실패했습니다. \n아이디 또는 비밀번호를 확인해주세요."
          );
        }
      }
    } catch (err) {
      console.error("Login 실패:", err);
      if (err?.response?.status === 403) {
        setErrorMessage("탈퇴처리 되었습니다");
      } else {
        setErrorMessage("로그인에 실패했습니다. \n아이디 또는 비밀번호를 확인해주세요.");
      }
    }
  };

  const closeErrorPopup = () => {
    setErrorMessage("");
  };

  const client_id = import.meta.env.VITE_NAVER_CLIENT_ID;
  const redirectURI = encodeURIComponent(
    import.meta.env.VITE_NAVER_REDIRECT_URI
  );
  const state = import.meta.env.VITE_NAVER_STATE;
  const naverLoginUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirectURI}&state=${state}`;
  return (
    <>
      <div className=" flex w-full">
        <div className="flex flex-col justify-center items-center w-full pt-28 ">
          <div className="flex justify-center items-center w-full">
            <img
              src={logoNavbar}
              alt="Logo"
              className="flex justify-center h-12 "
            />
          </div>
          <form
            onSubmit={handleSubmit}
            className="flex flex-col text-gray-500 gap-3 pt-10 md:w-6/12 lg:w-4/12 w-10/12"
          >
            <input
              name="username"
              className={clsx(
                `focus:${themeClass.outline("text")}`,
                `rounded-full w-full border px-4 py-3 `
              )}
              placeholder="이메일"
              value={formData.username}
              onChange={handleChange}
              required
            />
            <input
              name="password"
              type="password"
              className={clsx(
                `focus:${themeClass.outline("text")}`,
                `rounded-full w-full border px-4 py-3`
              )}
              placeholder="비밀번호"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <div className="flex justify-end">
              <div className="flex items-center gap-2">
                <input
                  className="rounded-full border-gray-300 focus:outline-none text-gray-500"
                  type="checkbox"
                  value="option2"
                />
                <p className="text-black">자동로그인</p>
              </div>
            </div>
            <button
              type="submit" // Pastikan type adalah submit
              className={clsx(
                themeClass.bgNohex("text2"),
                `rounded-full px-4 py-3 w-full text-white`
              )}
            >
              로그인
            </button>

            <a
              href={naverLoginUrl}
              className="flex justify-center items-center gap-2 bg-[#03C75A] text-white rounded-full py-3 cursor-pointer"
            >
              <img src={naver} alt="Naver" className="h-4" />
            </a>
            <div className="flex justify-center gap-2">
              {/* <Link to={"/find-username"} className="underline text-blue-400">이메일</Link> */}
              {/* <p>또는</p> */}
              <Link to={"/forgot-password"} className="underline text-blue-400">
                비밀번호
              </Link>
              <p>찾기</p>
            </div>
            <p className="text-black font-bold pt-10">
              아직 회원가입을 안하셨다면?
            </p>
            <Link to="/register">
              <div className="bg-black rounded"></div>
              <button className="rounded-full px-4 py-3 w-full text-white bg-black text-sm">
                회원가입
              </button>
            </Link>
          </form>
        </div>
      </div>

      {/* Pop-up untuk error */}
      {errorMessage && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-md shadow-md text-center max-w-sm w-11/12">
            {errorMessage.split("\n").map((line, idx) => (
              <p key={idx} className="font-semibold break-words leading-7">
                {line}
              </p>
            ))}
            <button
              className="mt-4 px-7 py-2 bg-black text-white rounded-full"
              onClick={closeErrorPopup}
            >
              닫기
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default MainLogin;
